import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface IResSwipeCallbacks {
  swipeLeft?: () => void;
  swipeRight?: () => void;
  swipeTop?: () => void;
  swipeBottom?: () => void;
  tap?: () => void;
}

@Injectable({
  providedIn: 'root',
})
export class ResSwipeService {
  public swipeCallbacks = new BehaviorSubject<IResSwipeCallbacks>({});

  private touchstartX = 0;
  private touchendX = 0;
  private touchstartY = 0;
  private touchendY = 0;

  private readonly boundTouchstart = (event: TouchEvent) => this.onTouchStart(event);
  private readonly boundTouchend = (event: TouchEvent) => this.onTouchEnd(event);

  private onTouchStart(event: TouchEvent) {
    this.touchstartX = event.changedTouches[0].screenX;
    this.touchstartY = event.changedTouches[0].screenY;
  }

  private onTouchEnd(event: TouchEvent) {
    this.touchendX = event.changedTouches[0].screenX;
    this.touchendY = event.changedTouches[0].screenY;
    this.handleGesture();
  }

  public handleGesture() {
    const {
      swipeLeft = () => {},
      swipeRight = () => {},
      swipeTop = () => {},
      swipeBottom = () => {},
      tap = () => {},
    } = this.swipeCallbacks.value;

    if (this.touchendX < this.touchstartX) {
      swipeLeft();
    }

    if (this.touchendX > this.touchstartX) {
      swipeRight();
    }

    if (this.touchendY < this.touchstartY) {
      swipeTop();
    }

    if (this.touchendY > this.touchstartY) {
      swipeBottom();
    }

    if (this.touchendY === this.touchstartY) {
      tap();
    }
  }

  public handleSwipe() {
    window.addEventListener('touchstart', this.boundTouchstart, false);
    window.addEventListener('touchend', this.boundTouchend, false);
  }

  public removeHandleSwipe() {
    window.removeEventListener('touchstart', this.boundTouchstart, false);
    window.removeEventListener('touchend', this.boundTouchend, false);
  }
}
